// Limite ondulado entre secções, com um fio tracejado (pontos de costura) a acompanhar a onda. `flip` vira-o para baixo.
// A onda e o fio usam o mesmo azulejo de 60 px, por isso ficam sempre alinhados, seja qual for a largura do ecrã.
const H = 30;
const enc = (svg) => `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
const MASK = enc(`<svg xmlns="http://www.w3.org/2000/svg" width="60" height="${H}" viewBox="0 0 60 ${H}"><path d="M0 12 Q15 1 30 12 T60 12 V${H} H0 Z" fill="#000"/></svg>`);
const stitchTile = (color) => enc(`<svg xmlns="http://www.w3.org/2000/svg" width="60" height="${H}" viewBox="0 0 60 ${H}"><path d="M0 12 Q15 1 30 12 T60 12" transform="translate(0 7)" fill="none" stroke="${color}" stroke-width="2" pathLength="60" stroke-dasharray="5 5"/></svg>`);

// `background`: valor CSS do fundo da secção (para a onda o continuar sem emenda); `bgSize` o tamanho dos seus padrões.
export const StitchWave = ({ flip = false, color = "currentColor", stitch = "rgba(117,67,75,.5)", background, bgSize }) => {
  const pos = flip ? "bottom-[-29px] rotate-180" : "top-[-29px]";
  return (
    <>
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute inset-x-0 z-10 h-[30px] ${pos}`}
        style={{ background: background ?? color, backgroundSize: bgSize, backgroundPosition: "0 29px", WebkitMaskImage: MASK, maskImage: MASK, WebkitMaskSize: "60px 30px", maskSize: "60px 30px", WebkitMaskRepeat: "repeat-x", maskRepeat: "repeat-x" }}
      />
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute inset-x-0 z-10 h-[30px] ${pos}`}
        style={{ backgroundImage: stitchTile(stitch), backgroundSize: "60px 30px", backgroundRepeat: "repeat-x", backgroundPosition: "0 0" }}
      />
    </>
  );
};
